module.exports = __webpack_public_path__ + "media/images/flags/1x1/zwe-5a751883271b7005c402b2329d2bbf0b.svg";